var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"middle-align"},[_c('TextField',{staticClass:"m1",attrs:{"id":'partnerLink',"placeholder":_vm.$t('hear_the_music'),"value":_vm.account.client.settings_HtM_url}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }